import React, { useState, useEffect } from "react";
import { CloseIcon, CheckIcon } from "../../../Icons";
import {
  INVOICE_BTN,
  INVOICE_FIELD,
  INVOICE_MODAL,
} from "../invoiceTheme";
import { visitTypeDisplayLabel } from "../invoiceLineItem";

const RateModal = ({ show, onClose, rates, onSave, visitTypes }) => {
  const [localRates, setLocalRates] = useState({});

  useEffect(() => {
    if (show) {
      setLocalRates(rates || {});
    }
  }, [show, rates]);

  const handleChange = (type, value) => {
    setLocalRates((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  if (!show) return null;

  return (
    <div
      className={INVOICE_MODAL.backdrop}
      role="dialog"
      aria-modal="true"
      aria-labelledby="manage-rates-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className={INVOICE_MODAL.panelSm}>
        <div className={INVOICE_MODAL.head}>
          <div className="min-w-0">
            <h2 id="manage-rates-title" className={INVOICE_MODAL.title}>
              Manage Rates
            </h2>
            <p className={INVOICE_MODAL.subtitle}>
              Set default visit type rates
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className={INVOICE_MODAL.close}
            aria-label="Close"
          >
            <CloseIcon size={14} />
          </button>
        </div>

        <div className={`${INVOICE_MODAL.body} max-h-[70vh]`}>
          <div className="space-y-3">
            {visitTypes.map((type) => (
              <div key={type}>
                <label className={INVOICE_FIELD.label}>
                  {visitTypeDisplayLabel(type)}
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm">
                    $
                  </span>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={localRates[type] || ""}
                    onChange={(e) => handleChange(type, e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e" || e.key === "E") {
                        e.preventDefault();
                      }
                    }}
                    className={INVOICE_FIELD.input}
                    placeholder="0.00"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={INVOICE_MODAL.footer}>
          <button
            type="button"
            onClick={onClose}
            className={INVOICE_BTN.modalCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onSave(localRates)}
            className={INVOICE_BTN.modalPrimary}
          >
            <CheckIcon size={14} />
            Save Rates
          </button>
        </div>
      </div>
    </div>
  );
};

export default RateModal;
